import React, {useState, useEffect} from 'react'
import 'chart.js/auto';

import { Chart } from "react-google-charts";

function Contact() {
    const [chartData, setChartData] = useState([])
    //create array of array as input for graph coordinates
    const arr = chartData.map(d => [d.timestamp ? new Date(d.timestamp) : 'N/A',d.stateOfCharge ? d.stateOfCharge : 0])
    
    useEffect(() => {
        const fetchPrices = async () => {
        const res = await fetch("https://f2byongc84.execute-api.eu-central-1.amazonaws.com/webdev_test_fetch_batteries?id=C-76800")
        const data = await res.json()
        setChartData(data.measurements)
        
}
    fetchPrices()
  }, []);
  return (
    <div>
        <h1>Contact</h1>
        
         <Chart
            chartType="LineChart"
            data={[[ "Timestamp","StateOfCharge"], ...arr]}
            width="100%"
            height="400px"
            legendToggle
        /> 
    </div>
  )
}

export default Contact